import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {DocumentActions, FEATURE} from '../../redux/actions/documents';
import {CommandActions as DocumentCommandActions} from '../../redux/actions/document';
import {CommandActions as DocumentsCommandActions, DocumentActions as DocumentDocumentsActions} from '../../redux/actions/documents';
import {Actions as ModalActions} from '@pwbapps/genericdialog';
import {CommandActions as FiltersCommandActions} from '../../redux/actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import CommandBar from './command_bar/index'
import Notification from '../notification/index';
import { getNotification } from '../../redux/selectors/notification';
import { getFilterPanelOpened } from '../../redux/reducers/ui';
import { getLoader } from '../../redux/selectors/loader';
import { IColumn, MessageBarType, ProgressIndicator, Spinner, SpinnerSize, Selection } from '@fluentui/react';
import { getClassNames } from './index.classNames';
import { getColumns } from '../documents/columns';
import SelectedFilters from '../filtersPanel/filters/selectedFilters';
import _ from 'lodash';
import { getOrderColumn, getTotal } from '../../redux/reducers/documents';
import DocumentModal from '../modals/document'
import DocumentsGrid from '../documents/index'
import { getSelectedProjectUserActions } from '../../redux/selectors/auth';
import { getFilters } from '../../redux/reducers/filters';
import { Filters } from '../../models/filters';
import { getNotificationWidth } from '../../redux/selectors/ui';
import CalloutFilters from '../filtersPanel/callout/index';
import { MainCompGenerator as GenericModalGenerator, Actions as GenericModalActions } from '@pwbapps/genericdialog'
import DownloadComments from '../documents/functionalities/downloadComments';
import DownloadExcelReport from '../documents/functionalities/downloadExcelReport';
import { InternalRoleActionsType, ExternalRoleActionsType, isExternalApp, getTheme } from '../../utils/costants';
import { getHistoryName } from '../../utils/functions';
import { getContextualDocuments } from '../../redux/selectors/documents';
import { Document, FileForm } from '../../models/document';
import { Status } from '../../models/status';
import UploadParentFile from '../documents/functionalities/uploadParentFileSupplier';
import ImportZip from '../documents/functionalities/importZip';
import { Type } from '../../models/type';
import { withTranslation, WithTranslation  } from 'react-i18next';
import { getEmail } from '@pwbapps/reduxcore/dist/redux/reducers/auth';
import { getDarkModeEnabled, getHasPartner, getSelectedProjectId } from '../../redux/reducers/project';
import { getSelectedProjectDaysToApproval } from '../../redux/selectors/project';
import DownloadFiles from '../documents/functionalities/downloadFiles';

let GenericModal = GenericModalGenerator();

export interface ReservedNumbersProps extends RouteComponentProps, WithTranslation {
    loading: boolean,
    loadingContent: boolean,
    loadingScroll: boolean,
    documents: Document[]
    filterPanelOpened: boolean, 
    showNotification: boolean, 
    type: MessageBarType, 
    message: string,
    userProjectActions: InternalRoleActionsType[] | ExternalRoleActionsType[],
    filters: Filters,
    showCallout: boolean,
    orderColumn: {name: string, direction: string },
    total: number,
    changeStatusForm?: {
        newStatus: Status,
        fileForm?: FileForm,
        files?: any[]
    },
    notificationWidth: string,
    email?: string,
    darkModeEnabled: boolean,
    hasPartner: boolean,
    daysToApproval: number,
    selectedProjectid?: number,
    setSelectedItemsIds: typeof DocumentActions.setSelectedItemsIds,
    getDocumentAndOpenModal: typeof DocumentCommandActions.getDocumentAndOpenModal,
    showOrHideCallout: typeof FiltersCommandActions.showOrHideCallout,
    openGenericModal: typeof ModalActions.CommandActions.openModal,
    closeGenericModal: typeof ModalActions.CommandActions.closeModal,
    downloadOrShowFile: typeof DocumentsCommandActions.downloadOrShowFile,
    fetchDocuments: typeof DocumentsCommandActions.fetchDocuments,
    setSortColumn: typeof DocumentDocumentsActions.setSortColumn,
    downloadComments: typeof DocumentsCommandActions.downloadComments,
    downloadExcelReport: typeof DocumentsCommandActions.downloadExcelReport,
    downloadTemplate: typeof DocumentsCommandActions.downloadTemplate,
    uploadSupplierFile: typeof DocumentsCommandActions.uploadSupplierFile,
    downloadFiles: typeof DocumentsCommandActions.downloadFiles,
}
class ReservedNumbers extends React.Component<ReservedNumbersProps & RouteComponentProps> {
    constructor(props: ReservedNumbersProps) {
        super(props);   
    }

    getKey = (item: any, index?: number): string => {
        return item.id;
    }

    getFilters = (): Filters => {
        const { filters } = this.props;
        return filters;
    }

    getFilterPanel = (): boolean => {
        const { filterPanelOpened } = this.props;
        return filterPanelOpened;
    }

    onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { fetchDocuments, setSortColumn } = this.props; 
        setSortColumn({colName: column.fieldName as string, direction: (column.isSortedDescending) ? 'asc' : 'desc', feature: FEATURE});
        //this.selection.setAllSelected(false);    
        fetchDocuments({});
    };

    selection = new Selection({		
        getKey: this.getKey,
		onSelectionChanged: () => {
            let rows = this.selection.getSelection() as any;
            const {setSelectedItemsIds} = this.props;
            let ids = (rows) ? _.map(rows, (r: Document) => {return r.id as number}) : [];
            setSelectedItemsIds({ids: _.map(ids, id => id.toString()), feature: FEATURE}) 
		}
    });

    render(){
        const {loading, loadingContent, showNotification, type, message, filterPanelOpened, orderColumn, loadingScroll, userProjectActions, documents, notificationWidth, t, email, darkModeEnabled,
               history, hasPartner, daysToApproval, selectedProjectid, total, getDocumentAndOpenModal, showOrHideCallout, closeGenericModal, downloadOrShowFile, openGenericModal, uploadSupplierFile,
               downloadComments, downloadExcelReport, downloadFiles} = this.props;
        const styles = getClassNames(filterPanelOpened);
        const historyName = getHistoryName(history);
        const canRead = _.find(userProjectActions, a => a === 'ReadReservedNumbers') ? true : false;
        const canUploadParent = _.find(userProjectActions, a => a === 'UploadParentReservedNumbers') ? true : false;
        const columns = getColumns(selectedProjectid || 0, email as string, t, canRead, false, this.selection, this.getFilterPanel, getDocumentAndOpenModal, this.getFilters, showOrHideCallout, downloadOrShowFile, this.onColumnClick, orderColumn, historyName, openGenericModal, canUploadParent, undefined, _.some(userProjectActions, a => a === 'FilterDocumentsByPartnerId'), getTheme(darkModeEnabled), hasPartner, daysToApproval);
        const singleSelectedDocument = (documents && documents.length === 1) ? documents[0] : undefined;
        const disableDownloald = !((documents.length === 0 && total < 500) || (documents.length > 0 && documents.length < 500));
        return (
            <>
                <CommandBar userProjectActions={userProjectActions} loading={loading} loadingContent={loadingContent} loadingScroll={loadingScroll}/>
                <div style={{position: 'absolute', width: notificationWidth, top: 99, zIndex: 10}}>
                    {!loading && !loadingContent && <Notification name={'reservedNumbers'} show={showNotification} type={type} message={message}/>}
                </div>
                {!loading && <SelectedFilters selection={this.selection}/>}
                <ProgressIndicator styles={{root: {height: 10}}} progressHidden={ !loadingContent || loading }/> 
                {loading && <Spinner size={SpinnerSize.large} style={{marginTop: 50}}></Spinner>}
                {!loading &&
                    <div className={styles.resultContainer}>
                        <DocumentsGrid selection={this.selection} columns={columns} loadingScroll={loadingScroll}/>
                        <DocumentModal userProjectActions={userProjectActions}/>
                    </div>
                }
                <CalloutFilters/>

                {singleSelectedDocument && 
                    <GenericModal 
                        id={'uploadParent'}
                        title={t('Upload file')}
                        message={''}                 
                        onClose={() => {closeGenericModal({id: 'uploadParent'})}}
                        btnCloseText={t('Cancel')}
                        onConfirm={() => {uploadSupplierFile()}}
                        btnConfirmText={t('Save')}
                        customComponent={<UploadParentFile loadingContent={loadingContent} type={singleSelectedDocument.type as Type}/>}
                        disableAutoModalClose 
                        disableClose={loadingContent}     
                        width={640}    
                    />      
                }
                <GenericModal 
                    id={'importZip'}
                    title={t('Import ZIP file')}
                    message={''}                 
                    onClose={() => {closeGenericModal({id: 'importZip'})}}
                    btnCloseText={t('Cancel')}
                    customComponent={<ImportZip loadingContent={loadingContent}/>}
                    disableAutoModalClose 
                    disableClose={loadingContent}        
                />   
                <GenericModal 
                    id={'comments'}
                    title={t('Download comments')}
                    message={''}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadComments()}}
                    btnConfirmText={t('Download')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadComments/>}
                    disableConfirm={loadingContent}     
                />
                <GenericModal 
                    id={'excelReport'}
                    title={t('Download Excel report')}
                    message={''}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadExcelReport()}}
                    btnConfirmText={t('Download')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadExcelReport/>}
                    disableConfirm={loadingContent}          
                />
                  <GenericModal 
                    id={'fileName'}
                    title={(!disableDownloald) ? t('Download files') : t('Attention')}
                    message={(!disableDownloald) ? '' : t('There are too many documents to download. Please select a number of documents less than 500')}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadFiles()}}
                    btnConfirmText={(!disableDownloald) ? t('Download') : undefined}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadFiles disableDownloald={disableDownloald}/>}
                    disableConfirm={loadingContent || disableDownloald}  
                />
                
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    loading: (state) => getLoader('reservedNumbers')(state).loading,
    loadingContent: (state) => getLoader('reservedNumbers')(state).loadingContent,
    loadingScroll: (state) => getLoader('reservedNumbers')(state).loadingScroll,
    showNotification: (state) => getNotification('reservedNumbers')(state).show,
    type: (state) => getNotification('reservedNumbers')(state).type,
    message: (state) => getNotification('reservedNumbers')(state).message,
    filterPanelOpened: getFilterPanelOpened,
    userProjectActions: getSelectedProjectUserActions,
    filters: getFilters,
    orderColumn: getOrderColumn,
    total: getTotal,
    documents : getContextualDocuments,
    notificationWidth: getNotificationWidth,
    email: getEmail,
    darkModeEnabled: getDarkModeEnabled,
    hasPartner: getHasPartner,
    daysToApproval: getSelectedProjectDaysToApproval,
    selectedProjectid: getSelectedProjectId,
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setSelectedItemsIds: DocumentActions.setSelectedItemsIds,
        getDocumentAndOpenModal: DocumentCommandActions.getDocumentAndOpenModal,
        showOrHideCallout: FiltersCommandActions.showOrHideCallout,
        openGenericModal: ModalActions.CommandActions.openModal,
        closeGenericModal: ModalActions.CommandActions.closeModal,
        downloadOrShowFile: DocumentsCommandActions.downloadOrShowFile,
        fetchDocuments: DocumentsCommandActions.fetchDocuments,
        setSortColumn: DocumentDocumentsActions.setSortColumn,
        downloadComments: DocumentsCommandActions.downloadComments,
        downloadExcelReport: DocumentsCommandActions.downloadExcelReport,
        downloadTemplate: DocumentsCommandActions.downloadTemplate,
        uploadSupplierFile: DocumentsCommandActions.uploadSupplierFile,
        downloadFiles: DocumentsCommandActions.downloadFiles,
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()(withRouter(ReservedNumbers)));